export default {
  name: 'ListTreeViewComponent',
  /**
   * MODELO
   *
   * Arreglo con los datos para mostrar en la lista.
   *
   * PROPIEDADES
   *
   * itemKey: nombre de la propiedad que representa el id de los objetos de la lista.
   * itemText: nombre de la propiedad que representa el texto para mostrar los objetos.
   * itemChildren: nombre de la propiedad que contiene los hijos de cada objeto.
   *
   * EVENTOS
   * change: evento que se lanza cuando se modifica el modelo.
   */
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    model: {
      type: Array,
      required: true
    },
    itemKey: {
      type: String,
      required: true
    },
    itemText: {
      type: String,
      required: true
    },
    itemChildren: {
      type: String,
      required: true
    }
  },
  components: {
  },
  data: () => ({
  }),
  computed: {
  },
  mounted () {
  },
  methods: {
  },
  watch: {
    model: function (val, oldVal) {
      console.log(val)
      console.log(oldVal)
    }
  }
}
